var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconChair48Line = function SvgIconChair48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8 23.65h-.1v-9.7c0-2.92-2.38-5.3-5.3-5.3H18.6a5.31 5.31 0 0 0-5.3 5.3v9.7h-.1c-1.6 0-2.9 1.3-2.9 2.9v2.6c0 1.6 1.3 2.9 2.9 2.9h9.1v2.1h-4.1c-1.6 0-2.9 1.3-2.9 2.9v2.3h3.4v-1.8h10.6v1.8h3.4v-2.3c0-1.6-1.3-2.9-2.9-2.9h-4.1v-2.1h9.1c1.6 0 2.9-1.3 2.9-2.9v-2.6c0-1.6-1.3-2.9-2.9-2.9Zm-18.1-9.7c0-1.05.85-1.9 1.9-1.9h10.8c1.05 0 1.9.85 1.9 1.9v9.7H16.7v-9.7Zm17.6 14.7H13.7v-1.6h20.6v1.6Z",
    fill: "current"
  })));
};
export default SvgIconChair48Line;